import type { FaireProductEntity } from "../../entity_types/product";

export const p_83vyxvu9: FaireProductEntity = {
  token: "p_83vyxvu9",
  type: "product",
  name: "You Did It! Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d089e2bbe072c7c42cdade0efc072ebc6cf780793288b2838057d1c720b36226/1528388743.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/12187470ef81d6df7c3833a3ec740b6c3b92bab5b0cbb794e8920c462f4e1eba/1528388742.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:22.608Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
